import { render, staticRenderFns } from "./SharerAction.vue?vue&type=template&id=61975376"
import script from "./SharerAction.vue?vue&type=script&lang=js"
export * from "./SharerAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports